/**
 * euronics.ie — custom.js
 * ───────────────────────
 * Slimmed 2026-06-12: removed the embedded jQuery 3.5.1 copy, the dead
 * Swiper/USP-slider init (Swiper was never loaded by the theme), legacy video
 * controls, the retired warranty popup (its product templates are gone) and
 * the unused drilldown menu. None of it was referenced by any live template,
 * and nothing in the theme depends on jQuery anymore.
 *
 * What remains (both verified in production):
 *   1. Add-to-cart double-submit guard (all pages, capture phase)
 *   2. Cart-page remove/decrease fix — avoids the stale-cache reload caused
 *      by window.location.reload() + instant.page prefetching
 */

document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form || !form.action) return;

  // Only target Shopify add-to-cart forms
  if (!form.action.includes('/cart/add')) return;

  // Prevent double submit
  if (form.dataset.submitting === 'true') {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  form.dataset.submitting = 'true';

  // Release lock after a short delay (so user can add again later)
  setTimeout(() => {
    form.dataset.submitting = 'false';
  }, 2000);
}, true);

/**
 * ─────────────────────────────────────────────────────────────
 * Cart Page — Fix remove / quantity not updating with 2+ items
 * ─────────────────────────────────────────────────────────────
 * The Warehouse theme's _updateQuantity calls window.location.reload()
 * after changing a line item. With browser caching and instant.page
 * prefetching, reload() can serve a stale page. This handler intercepts
 * remove/decrease clicks on the CART PAGE ONLY in the capture phase
 * (before the theme's delegated handler fires), performs the cart
 * change, then does a fresh navigation to the cart URL instead.
 */
(function() {
  // Only run on the cart page
  if (typeof window.theme === 'undefined' || window.theme.pageType !== 'cart') return;

  var cartChangeUrl = (window.routes && window.routes.cartChangeUrl)
    ? window.routes.cartChangeUrl + '.js'
    : '/cart/change.js';
  var cartPageUrl = (window.routes && window.routes.cartUrl)
    ? window.routes.cartUrl
    : '/cart';

  document.addEventListener('click', function(e) {
    // Match remove links AND decrease-quantity buttons inside the cart
    var target = e.target.closest('[data-action="decrease-quantity"]');
    if (!target) return;

    // Only intercept inside the cart section
    if (!target.closest('[data-section-type="cart"]')) return;

    var quantity = parseInt(target.getAttribute('data-quantity'), 10);
    var line = target.getAttribute('data-line');

    if (!line) return;

    // Take over — prevent default link navigation AND stop theme handler
    e.preventDefault();
    e.stopImmediatePropagation();

    // Visual feedback: fade out the line item row immediately if removing
    if (quantity === 0) {
      var lineItem = target.closest('.line-item');
      if (lineItem) {
        lineItem.style.transition = 'opacity 0.3s ease';
        lineItem.style.opacity = '0.3';
        lineItem.style.pointerEvents = 'none';
      }
    }

    // Show loading bar
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(cartChangeUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Cart change failed: ' + response.status);
      // Fresh navigation — bypasses bfcache and instant.page prefetch
      window.location.href = cartPageUrl;
    })
    .catch(function(err) {
      console.error('Cart update error:', err);
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      // Fallback: force hard reload with cache-bust
      window.location.href = cartPageUrl + '?v=' + Date.now();
    });
  }, true); // <-- capture phase: fires BEFORE theme's delegated listener
})();